import Component from 'vue-class-component';
import ProductGridElement from '../ProductGridElement/ProductGridElement';
import ProductListAbstract from '../ProductAbstract/ProductListAbstract';

@Component({
    components: {
        ProductGridElement,
    },
   
})

export default class ProductGrid extends ProductListAbstract {

}